import { makeStyles } from '@mui/styles';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles(() => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    title: {
      textAlign: 'center',
      margin: `0 auto ${pxToRem(22)}`,
    },
    table: {
      width: '100%',
      backgroundColor: Colors.White,
      border: `1px solid ${Colors.Gray1}`,
    },
    name: {
      color: Colors.Blue1,
      display: 'block',
    },
    email: {
      fontSize: 13,
    },
  };
});

export default useStyles;